import { render, staticRenderFns } from "./BarraCarga.vue?vue&type=template&id=3552612c&scoped=true"
import script from "./BarraCarga.vue?vue&type=script&lang=js"
export * from "./BarraCarga.vue?vue&type=script&lang=js"
import style0 from "./BarraCarga.vue?vue&type=style&index=0&id=3552612c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552612c",
  null
  
)

export default component.exports